import { ReportingFreq } from 'src/utils/api.interfaces';
import { ErrorBuilder, SchemaErrors } from 'src/utils/validation';

export interface RegistrationRabenSchema {
  token: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  organization_name: string;
  vat_identifier: string;
  reporting_period?: string;
  country: string | null;
  password: string;
  reporting_frequency: ReportingFreq;
  terms_of_service_consent: boolean;
}

export type FormErrors = SchemaErrors<RegistrationRabenSchema>;

export const firstPageFieldsRequired: (keyof RegistrationRabenSchema)[] = [
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'organization_name',
  'vat_identifier',
  'country',
  'terms_of_service_consent',
];

const applyFirstPageValidation = (
  builder: ErrorBuilder<RegistrationRabenSchema>
) => {
  builder
    .checkEmail(['email'], 'registration_raben.emailError')
    .checkTruthy(firstPageFieldsRequired, 'validation.required');
};

const applySecondPageValidation = (
  builder: ErrorBuilder<RegistrationRabenSchema>
) => {
  builder.checkTruthy(
    ['password', 'reporting_frequency'],
    'validation.required'
  );
};

export const validateForm = (data: RegistrationRabenSchema): FormErrors => {
  const builder = new ErrorBuilder(data);
  applyFirstPageValidation(builder);
  applySecondPageValidation(builder);
  return builder.build();
};

export const validateFormFirstPage = (
  data: RegistrationRabenSchema
): FormErrors => {
  const builder = new ErrorBuilder(data);
  applyFirstPageValidation(builder);
  return builder.build();
};
